// extracted by mini-css-extract-plugin
export default {"captchaText":"reportTechnical_captchaText__hZSzR","wobble":"reportTechnical_wobble__m1Vx9"};